import React, { useRef } from 'react';

import AllVehiclesCards from '../../Vehicles/subComponents/AllVehiclesCards';
import {TrashOutlineIcon} from '../../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../../components/buttons/ButtonAction';

const Step9DrivingPermits = ({ searchVehicle, handleCheckboxChange, selectVehicleForDelete, vehicleData, isAllChecked , handleCheckedAll, handleDelete}) => {

    const elementRefGrid = useRef(null);

    return (
        <>
            <div className='row'>
                <div className={`col-12 d-flex justify-content-end ${vehicleData?.length === 0 ? 'mb-4' : ''}`}>
                    <ButtonAction
                        id='btn_a9dp_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectVehicleForDelete?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={()=>{
                            handleDelete()
                        }}
                    />
                </div>
                <div className='col-12'>
                    <AllVehiclesCards
                        searchVehicle={searchVehicle}
                        vehicleData={{content:vehicleData}}
                        selectVehicleForDelete={selectVehicleForDelete}
                        handleCheckboxChange={handleCheckboxChange}
                        elementRef={elementRefGrid}
                        view={'grid'}
                        isAllChecked={isAllChecked}
                        handleCheckedAll={handleCheckedAll}
                        isSectionEmployee={true}
                        byVehicleId={true}
                        classNamePanelGrid='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 px-1 mb-3'
                    />
                </div>
            </div>

        </>
    );
};

export default Step9DrivingPermits;
